<template>
<div class="chapter">
<div class="inner_page">
<p class="intro-head"><a id="page_6"></a>INTRODUCTION</p>
<p class="noindentt">It is always wonderful to celebrate the milestones in life with a quilt—something that will last and commemorate the event. As quilters, we are fortunate that we are able to express our love for those around us with needle and thread. This book is full of sophisticated and modern designs to help you commemorate life’s memorable, special moments and milestones. I hope you will enjoy making these quilts as much as I’ve enjoyed designing them.</p>
<p class="noindentt">I have designed a quilt top and a quilt back for each project, which allows you to easily personalize them. You can piece the front design, the back design, or both! Each quilt back design is 5˝ larger in each direction than the quilt top design, allowing it to be mounted on a quilting machine with ease. (Make sure to center the top over it for a clean finish!) Each back design also features an area to personalize the quilt with a special message. You can read more ideas for how to do this in Personalizing Your Quilts.</p>
<p class="noindentt">I hope you enjoy making memories through quilting for the special people in your life!</p>
<p class="noindentt1">Happy quilting!</p>
<p class="noindentt">—Amanda</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_intro.vue?a42d5658